import { GET_CHAT } from '../actionTypes';

export default function(state = {}, action) {
    switch (action.type) {
        case GET_CHAT:
            return action.payload;
        default:
            return state;
    }
}
